<template>
  <div class="wrap">
    <Navbar :title="configs.title || ''">
      <template #title>
        <div class="nav_title" @click.stop="openMenu = true">
          {{ configs.title || '' }}
          <i class="iconfont icon-xiangxia"></i>
        </div>
      </template>
      <template #right>
        <i class="iconfont nav_tools_item" v-for="(item, index) in navTools" :key="`tool_${index}`" :class="item.icon"
          @click="item.click"></i>
      </template>
    </Navbar>
    <van-popup class="menu_popup" v-model="openMenu" position="top" :overlay-style="{
      backgroundColor: 'transparent'
    }" @click.stop="openMenu = false">
      <div class="menu" @click.stop>
        <div class="menu_list" :class="item.type == type ? 'menu_active' : ''" v-for="item, index in merchants"
          :key="index" @click="merchantsClick(item)">{{ item.title
          }}
        </div>
      </div>
    </van-popup>
    <div class="top_wrap" v-if="type.indexOf('hl') > -1">
      <div class="left">
        <div class="text">
          <span>{{ orderLists[0] && orderLists[0].expect }}</span>
          {{ $t("倒计时") }}
        </div>
        <div class="time">
          <template v-if="countTime > 0">
            <div class="time_num" v-for="item, index in countText.split(':')" :key="index">
              <div>
                {{ item }}
              </div>
              <span v-if="index != 2">:</span>
            </div>
          </template>
          <template v-else>{{ countText }}</template>
        </div>
      </div>
      <div class="right" @click="$router.push('/GameRecord?type=' + type)">
        <div class="text">
          <span>{{ orderLists[1] && orderLists[1].expect }}</span>
          {{ $t("比赛结果") }}
        </div>
        <template v-if="orderLists[1] || orderLists[0]">
          <div class="status" v-if="type.indexOf('hl') !== -1">
            <div class="ball_wraps">
              <div class="ball_img" v-for="item, index in (orderLists[1] || orderLists[0]).open.dwd" :key="index">
                <img class="img" :src="require(`../../../assets/icon/dice/${item}.png`)" alt="">
                <!-- {{ item }} -->
              </div>
            </div>
            <i class="iconfont icon-xiangxia"></i>
          </div>
          <div class="status txffc" v-else>
            <div class="ball_wrap">
              <div class="ball" v-for="(item, index) in (orderLists[1] || orderLists[0]).open
                .dwd" :key="index">
                {{ item }}
              </div>
            </div>
            <div class="sum_ball">
              <span class="label">{{ $t("game.typeHz") }}</span>
              <span class="sum">{{
                (orderLists[1] || orderLists[0]).open.zh.zh
              }}</span>
              <span class="result">{{
                `${getStatusText(
                  (orderLists[1] || orderLists[0]).open.zh.dx
                )} / ${getStatusText(
                  (orderLists[1] || orderLists[0]).open.zh.ds
                )}`
              }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <TxffcTop v-else :countTime="countTime" :timeCount="countText" :currentConfig="currentConfigs"
      :lastConfig="lastConfigs" :type="type" />
    <div class="daily_trade_info" :style="type.indexOf('hl') > -1 ? { borderRadius: '0 0 10px 10px' } : {}">
      <div :class="(type.indexOf('hl') > -1 || type.indexOf('qq') > -1) ? 'bet' : 'lefts'"
        :style="type.indexOf('qq') > -1 ? { border: 'none' } : {}">
        <div class="label">{{ $t('todayBetAmount') }}</div>
        <div class="value">{{ $money(dailyBet, false) }}</div>
      </div>
      <div :class="(type.indexOf('hl') > -1 || type.indexOf('qq') > -1) ? 'win' : 'lefts'"
        :style="type.indexOf('qq') > -1 ? { border: 'none' } : {}">
        <div class="label">{{ $t('todayWinAmount') }}</div>
        <div class="value">{{ $money(dailyWin, false) }}</div>
      </div>
    </div>
    <div class="content_wrap">
      <div class="newGame" v-if="type.indexOf('hl') == -1">
        <div class="gameLists" v-for="index in 3" :key="index">
          <div class="title">{{ $t('list_tableNumber' + index) }}</div>
          <div class="list">
            <div class="list_value" :class="newDxdsCode[index - 1].includes(value.value) ? 'list_active' : ''"
              v-for="value, num in newselectTypes" :key="num" @click="newDxdsClick(value, index, num)">
              <div class="title">{{ value.title }}</div>
              <div class="value">{{ newResultDxds['dxds']?.odds }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="select_wraps" :class="type.indexOf('hl') == -1 ? '_wrap' : ''"
        :style="type.indexOf('hl') == -1 && { marginTop: 0 }">
        <div class="all_title" v-if="type.indexOf('hl') == -1">{{ $t('list_tableAll') }}</div>
        <div class="select_wrap">
          <div class="select_item" v-for="(item, index) in selectTypes" :key="index"
            :class="!!selectArr.find((a) => a == item.value) && 'active'" @click="select(item)">
            <template>
              <p>{{ item.title }}</p>
              <p>{{ (dxdsArr[index] && dxdsArr[index].odds) || 0 }}</p>
            </template>
          </div>
          <div class="select_item" v-for="(item, index) in games" :key="`num_${index}`"
            :class="!!numSelectArr.find((a) => a == item.title) && 'active'" @click="numSelect(item)">
            <p>{{ item.title }}</p>
            <p>{{ item.odds || 0 }}</p>
          </div>
          <div class="select_item" v-for="index in games.length % 4" :key="index"></div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="input_wrap" v-if="showInput || getNewDxdsLength()">
        <div class="left">
          <span>{{
            `${$t("game.perPrice.text")} ${verConfig.moneyType}:`
          }}</span>
          <input v-model="perPrice" type="number" :placeholder="$t('input.permoney.placeholder')" />
          <!-- <span>元</span> -->
        </div>
        <div class="clear" @click="clear">
          <div class="icon">
            <van-icon name="delete-o" size="20" />
          </div>
          <div class="text">{{ $t("btn.clear") }}</div>
        </div>
        <!-- <div class="right">
          <span>{{ `${$t("balance.text")}:` }}</span>
          <span class="price">{{ userInfo.money || "0.00" }}</span>
        </div> -->
      </div>
      <div class="bottom">
        <div class="right">
          <span>{{ `${$t("balance.text")}:` }}</span>
          <span class="price">{{ userInfo.money || "0.00" }} {{ verConfig.moneyType }}</span>
        </div>
        <!-- <div class="clear" @click="clear">
          <div class="icon">
            <van-icon name="delete-o" size="20" />
          </div>
          <div class="text">{{ $t("btn.clear") }}</div>
        </div> -->
        <div class="buy" @click="toConfirmMatch">{{ $t("bet") }}</div>
      </div>
    </div>
    <!-- 右边弹窗 -->
    <div class="right_popup_wrap">
      <van-popup v-model="rightShow" position="top">
        <div class="tool_wrap">
          <div class="tool_item" v-for="(item, index) in tools" :key="index"
            :style="{ borderBottom: index === tools.length - 1 ? '0' : '' }" @click="item.fun">
            {{ item.title }}
          </div>
        </div>
      </van-popup>
    </div>
    <!-- 下单弹窗 -->
    <van-popup class="buy_pop" v-model="buyShow" closeable close-icon-position="top-left" position="bottom">
      <div class="title">{{ $t("popup.title.buyConfirm") }}</div>
      <div class="content">
        <div class="li">
          <div class="left">{{ configs.title }}:</div>
          <div class="right">
            {{
              (orderLists[0] && orderLists[0].expect) ||
              "" + $t("popup.text.data")
            }}
          </div>
        </div>
        <div class="li">
          <div class="left">{{ $t("popup.title.matchAmount") }}:</div>
          <div class="right" style="color: #fff">
            <!-- {{
              `${[...selectArr, ...numSelectArr].length * perPrice}${
                verConfig.moneyType
              }`
            }} -->
            {{ $money((matchAmount + getNewDxdsLength() + qqSelectArr.length) * (this.perPrice || 0), false) }}
          </div>
        </div>
        <template v-if="type.indexOf('qq') > -1">
          <div class="titles">{{ $t("popup.title.matchContent") }}:</div>
          <div class="li" v-if="qqSelectArr.length">
            <div class="left">{{ $t("骰子") }}:</div>
            <div class="right_qq">
              <div class="qq_img" v-for="(item, index) in qqSelectArr" :key="index">
                <img class="img" :src="require(`../../../assets/new/game/${item}.png`)" alt="">
              </div>
            </div>
          </div>
          <div class="li" v-for="(item, index) in txffcGames" :key="`content_${index}`"
            v-show="(txffcSelectData[index] || []).length">
            <div class="left">{{ $t(`game.fiveBall.${index}`) }}:</div>
            <div class="right">
              <span style="margin-left: calc(5rem / 16)" v-for="(item, index) in txffcSelectData[index] || []"
                :key="index">
                {{ getStatusText(item) }}&nbsp;
              </span>
            </div>
          </div>
          <div class="li" v-if="getNewDxdsLength()">
            <div class="left">{{ $t("game.typeHz") }}:</div>
            <div class="right">
              <span v-for="(item, index) in newDxdsCode" :key="index">
                <div class="right_new" v-if="getStatusTexts(item).length > 0">
                  <span class="number">{{ index + 1 }}</span>&nbsp;
                  <div class="new_list" v-for="(value, num) in getStatusTexts(item)" :key="num">
                    <span class="value">{{ getStatusText(value) }}</span>
                    <span class="icon">,</span>
                  </div>
                </div>
              </span>
            </div>
          </div>
          <div class="li" v-if="[...selectArr, ...numSelectArr].length">
            <div class="left">{{ $t("popup.title.matchContent") }}:</div>
            <div class="right">
              <span style="margin-left: calc(5rem / 16)" v-for="(item, index) in [...selectArr, ...numSelectArr]"
                :key="index">
                {{ getStatusText(item) }}&nbsp;
              </span>
            </div>
          </div>
        </template>
        <template v-else-if="type.indexOf('hl') == -1">
          <div class="titles">{{ $t("popup.title.matchContent") }}:</div>
          <div class="li" v-for="(item, index) in txffcGames" :key="`content_${index}`"
            v-show="(txffcSelectData[index] || []).length">
            <div class="left">{{ $t(`game.fiveBall.${index}`) }}:</div>
            <div class="right">
              <span style="margin-left: calc(5rem / 16)" v-for="(item, index) in txffcSelectData[index] || []"
                :key="index">
                {{ getStatusText(item) }}&nbsp;
              </span>
            </div>
          </div>
          <div class="li" v-if="selectArr.length">
            <div class="left">{{ $t("game.typeHz") }}:</div>
            <div class="right">
              <span style="margin-left: calc(5rem / 16)" v-for="(item, index) in [...selectArr]" :key="index">
                {{ getStatusText(item) }}&nbsp;
              </span>
            </div>
          </div>
          <div class="li" v-if="getNewDxdsLength()">
            <div class="left">{{ $t("game.typeHz") }}:</div>
            <div class="right">
              <span v-for="(item, index) in newDxdsCode" :key="index">
                <div class="right_new" v-if="getStatusTexts(item).length > 0">
                  <span class="number">{{ index + 1 }}</span>&nbsp;
                  <div class="new_list" v-for="(value, num) in getStatusTexts(item)" :key="num">
                    <span class="value">{{ getStatusText(value) }}</span>
                    <span class="icon">,</span>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </template>
        <div class="li" v-else>
          <div class="left">{{ $t("popup.title.matchContent") }}:</div>
          <div class="right">
            <span style="margin-left: calc(5rem / 16)" v-for="(item, index) in [...selectArr, ...numSelectArr]"
              :key="index">
              {{ getStatusText(item) }}&nbsp;
            </span>
          </div>
        </div>
      </div>
      <div class="hint">
        {{ $t("hint.confirmBuy") }}
      </div>
      <div class="btn_wrap">
        <div class="btn" @click="toMatch">{{ $t("bet") }}</div>
      </div>
    </van-popup>
    <!-- 列表弹窗 -->
    <van-popup class="buy_pop" v-model="orderShow" closeable position="bottom" :style="{ maxHeight: '50vh' }">
      <div class="sticky">
        <div class="title">
          {{ $t("popup.title.matchResult") }}
          <div class="icon">
            <van-icon @click="orderShow = false" name="cross" size="22" color="#c8c9cc" />
          </div>
        </div>
        <div class="title_bar">
          <div class="li">{{ $t("popup.orderId") }}</div>
          <div class="li">{{ $t("open.result") }}</div>
        </div>
      </div>
      <div class="list_wrap">
        <div class="li_wrap" v-for="(item, index) in orderLists.filter(
          (a) => Object.keys(a.open).length > 0
        )" :key="index">
          <div class="li">{{ item.expect }}</div>
          <div class="li">
            <template v-if="type.indexOf('hl') !== -1">
              <img v-for="(r_item, r_index) in item.open.dwd" :key="'result' + index + r_index"
                :src="require(`@/assets/icon/dice/${r_item}.png`)" alt="" />
            </template>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 规则弹窗 -->
    <Dialog v-model="showRule" :title="$t('游戏规则')" show-cancel-button :show-confirm-button="false"
      :cancel-button-text="$t('btn.cancel')">
      <div class="rule_cont" v-html="ruleContent"></div>
    </Dialog>
    <Dialog v-model="dialogShow" class="wins" :show-confirm-button="false">
      <img src="../../../assets/new/game/dialog.png" alt="">
      <div class="win_cont">
        <div class="title">{{ $t('你赢了') }}</div>
        <div class="subtitle">{{ $t('赢了') }} <span>{{ last_win }}</span> !</div>
        <div class="btn" @click="dialogSubmit">{{ $t('My.Button.Two') }}</div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { $post, $get,cancelAllRequests } from "@/utils/request";
import { post } from "@/utils/newRequest";
import Navbar from "@/components/JNav";
import TxffcTop from "./components/txffcTop.vue";
import {
  cookie,
  LOTTERY_OPENING_EVENT,
  LOTTERY_ORDER_SETTLED_EVENT,
  LOTTERY_RESULT_EVENT,
  subscribeLotteryUser
} from "@/utils";
import {
  NavBar,
  cell,
  icon,
  field,
  Dialog,
  Toast,
  Tab,
  Tabs,
  Popup,
  DropdownMenu,
  DropdownItem
} from "vant";
export default {
  components: {
    [NavBar.name]: NavBar,
    [icon.name]: icon,
    [Popup.name]: Popup,
    Toast,
    Navbar,
    Dialog: Dialog.Component,
    TxffcTop,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  data() {
    this.navTools = [
      {
        icon: "icon-f4f5f8",
        title: "rule",
        click: () => {
          this.showRule = true;
        },
      },
      {
        icon: "icon-guizeguanli",
        title: "record",
        click: () => {
          this.toRecord();
        },
      },
      {
        icon: "icon-gengduo",
        title: "more",
        click: () => {
          this.rightShow = !this.rightShow;
        },
      },
    ];
    this.selectTypes = [
      { title: this.$t("open.big"), value: "大" },
      { title: this.$t("open.small"), value: "小" },
      { title: this.$t("open.single"), value: "单" },
      { title: this.$t("open.double"), value: "双" },
    ];
    this.newselectTypes = [
      { title: this.$t("open.big"), value: "大", methods: 'hz-hz-big' },
      { title: this.$t("open.small"), value: "小", methods: 'hz-hz-small' },
      { title: this.$t("open.single"), value: "单", methods: 'hz-hz-single' },
      { title: this.$t("open.double"), value: "双", methods: 'hz-hz-dual' },
    ];
    return {
      configs: {},
      rightShow: false,
      orderLists: [],
      selectArr: [],
      perPrice: "",
      userInfo: {},
      interval: null,
      countText: "00:00:00",
      countTime: 0,
      buyShow: false,
      orderShow: false,
      games: [],
      dxdsConfig: {},
      numSelectArr: [],
      ruleContent: "",
      showRule: false,
      txffcGames: [],
      txffcSelectData: {},
      currentGame: {},
      dxdsArr: [],
      isFindIndex: '',
      newDxdsArr: [],
      newResultDxds: {},
      newDxdsCode: ['', '', ''],
      timer: null,
      timer1: null,
      dailyBet: 0,
      dailyWin: 0,
      lastCurrent: {},
      num: -1,
      qqArr: [],
      qqSelectArr: [],
      type: this.$route.query.type,
      openMenu: false,
      dialogArr: [],
      dialogShow: false,
      last_win: 0,
      isVisible: true,
      countdownSocketStarted: false,
      countdownSocketVersion: 0,
      receivedLotteryResults: Object.create(null)
    };
  },
  created() {
    this.getRoomData();
    this.getOrders();
    this.getUserInfo();
  },
  mounted() {
    window.scrollTo(0, 0);
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    window.addEventListener(LOTTERY_OPENING_EVENT, this.handleLotteryOpening)
    window.addEventListener(LOTTERY_RESULT_EVENT, this.handleLotteryResult)
    window.addEventListener(LOTTERY_ORDER_SETTLED_EVENT, this.handleLotteryOrderSettled)
  },
  computed: {
    // type() {
    //   const { type } = this.$route.query;
    //   return type;
    // },
    tools() {
      return [
        // { title: this.$t("tab.record"), fun: () => this.toRecord() },
        { title: this.$t("btn.recharge"), fun: () => this.toRecharge() },
        { title: this.$t("btn.withdraw"), fun: () => this.toWithdraw() },
        // { title: this.$t("btn.service"), fun: () => this.toService() },
      ];

    },
    showInput() {
      let flag = false;
      for (const key in this.txffcSelectData) {
        if (Object.hasOwnProperty.call(this.txffcSelectData, key)) {
          const arr = this.txffcSelectData[key];
          if (arr.length) {
            flag = true;
          }
        }
      }
      return flag || [...this.selectArr, ...this.numSelectArr, ...this.qqSelectArr].length;
    },
    txffcMatchNum() {
      let num = 0;
      for (const key in this.txffcSelectData) {
        if (Object.hasOwnProperty.call(this.txffcSelectData, key)) {
          const item = this.txffcSelectData[key] || [];
          num += item.length;
        }
      }
      return num;
    },
    matchAmount() {
      let num = this.txffcMatchNum;
      num += [...this.selectArr, ...this.numSelectArr].length;
      return num;
    },
    currentConfigs() {
      return this.currentGame;
    },
    lastConfigs() {
      return this.orderLists[1] || this.orderLists[0] || {};
    },
    merchants() {
      let game = this.$store.getters.GameCategoryList;
      let _obj = game.find(item => item.types.includes(this.type))?.types || [];
      let games = this.$store.getters.AllGameList;
      let result = games.filter(item => {
        return _obj.includes(item.type);
      });
      return result;
      // if (this.type.includes('hl')) {
      //   return games.filter(item => item.type.includes('hl'))
      // }
      // return games.filter(item => !item.type.includes('hl') && !item.type.includes('qq'))
    },
  },
  methods: {
    compareExpect(left, right) {
      const leftValue = String(left || '');
      const rightValue = String(right || '');
      if (/^\d+$/.test(leftValue) && /^\d+$/.test(rightValue)) {
        const normalizedLeft = leftValue.replace(/^0+(?=\d)/, '');
        const normalizedRight = rightValue.replace(/^0+(?=\d)/, '');
        if (normalizedLeft.length !== normalizedRight.length) {
          return normalizedLeft.length > normalizedRight.length ? 1 : -1;
        }
        if (normalizedLeft === normalizedRight) return 0;
        return normalizedLeft > normalizedRight ? 1 : -1;
      }
      return leftValue.localeCompare(rightValue);
    },
    handleLotteryOpening(event) {
      const opening = event && event.detail;
      if (!opening || !opening.type || !opening.expect) return;
      if (String(opening.type) !== String(this.type)) return;

      const expect = String(opening.expect);
      const currentExpect = this.currentGame && this.currentGame.expect !== undefined
        ? String(this.currentGame.expect)
        : '';
      if (currentExpect && this.compareExpect(expect, currentExpect) < 0) return;

      const endtime = Number(opening.endtime);
      const serverTime = Number(opening.server_time);
      if (!Number.isFinite(endtime) || !Number.isFinite(serverTime)) return;

      const countdown = Math.max(0, Math.floor(endtime - serverTime));
      const current = {
        ...this.currentGame,
        ...opening,
        expect,
        countdown,
      };

      this.countdownSocketStarted = true;
      this.countdownSocketVersion += 1;
      this.currentGame = current;
      if (this.orderLists.length) {
        this.$set(this.orderLists, 0, {
          ...this.orderLists[0],
          ...current,
        });
      } else {
        this.orderLists = [current];
      }
      this.addInterval(countdown);
    },
    buildLotteryOpen(code) {
      const codeText = String(code === undefined || code === null ? '' : code).trim();
      const dwd = codeText.includes(',')
        ? codeText.split(',').map(item => item.trim()).filter(Boolean)
        : codeText.split('').filter(Boolean);
      const numbers = dwd.map(Number).filter(Number.isFinite);
      const sum = numbers.reduce((total, number) => total + number, 0);
      const isDice = String(this.type).includes('hl');
      const bigThreshold = isDice ? 11 : Math.ceil(numbers.length * 4.5);
      return {
        dwd,
        dxds: numbers.map(number => ({
          zh: number,
          dx: number > (isDice ? 3 : 4) ? '大' : '小',
          ds: number % 2 === 0 ? '双' : '单',
        })),
        zh: {
          zh: sum,
          dx: sum >= bigThreshold ? '大' : '小',
          ds: sum % 2 === 0 ? '双' : '单',
        },
      };
    },
    handleLotteryResult(event) {
      const result = event && event.detail;
      if (!result || !result.type || !result.expect || result.code === undefined) return;
      if (String(result.type) !== String(this.type)) return;

      const expect = String(result.expect);
      const lastExpect = this.lastCurrent && this.lastCurrent.expect !== undefined
        ? String(this.lastCurrent.expect)
        : '';
      if (lastExpect && this.compareExpect(expect, lastExpect) < 0) return;

      const key = `${result.type}:${expect}`;
      if (this.receivedLotteryResults[key]) return;
      this.receivedLotteryResults[key] = true;

      const resultItem = {
        ...this.lastCurrent,
        ...result,
        type: String(result.type),
        expect,
        code: String(result.code),
        status: '已开奖',
        countdown: 0,
        open: this.buildLotteryOpen(result.code),
      };
      this.lastCurrent = resultItem;
      if (this.orderLists.length) {
        this.$set(this.orderLists, 1, resultItem);
      } else {
        this.orderLists = [this.currentGame, resultItem];
      }
    },
    handleLotteryOrderSettled(event) {
      const settlement = event && event.detail;
      if (!settlement || !settlement.type || !settlement.expect || !Array.isArray(settlement.orders)) return;

      const balance = Number(settlement.balance);
      if (Number.isFinite(balance)) {
        this.$set(this.userInfo, 'money', balance);
        this.user_money = balance;
      }
      if (String(settlement.type) !== String(this.type)) return;

      const todayBet = Number(settlement.today_bet);
      const todayProfit = Number(settlement.today_profit);
      if (Number.isFinite(todayBet)) this.dailyBet = todayBet;
      if (Number.isFinite(todayProfit)) this.dailyWin = todayProfit;

      const expect = String(settlement.expect);
      const totalWin = settlement.orders.reduce((total, order) => {
        const winMoney = Number(String(order && order.winMoney !== undefined
          ? order.winMoney
          : 0).replace(/,/g, ''));
        return Number(total) + (Number.isFinite(winMoney) && winMoney > 0 ? winMoney : 0);
      }, 0);
      const roundedTotalWin = Number(totalWin.toFixed(2));
      if (roundedTotalWin <= 0) return;

      const arrItem = `${settlement.type}${expect}`;
      let gameExpect = {};
      try {
        gameExpect = JSON.parse(cookie.get('gameExpect') || '{}');
      } catch (error) {
        gameExpect = {};
      }
      if (this.dialogArr.includes(arrItem) || String(gameExpect[settlement.type] || '') === expect) return;

      this.lastCurrent = {
        ...this.lastCurrent,
        type: String(settlement.type),
        expect,
        code: settlement.code,
      };
      this.last_win = roundedTotalWin.toFixed(2);
      this.dialogShow = true;
      cookie.set('gameExpect', JSON.stringify({
        ...gameExpect,
        [settlement.type]: expect,
      }));
    },
    handleVisibilityChange() {
      this.isVisible = !document.hidden;
      if (!this.isVisible) { } else {
        this.getRoomData();
        if (!this.countdownSocketStarted) this.getOrders();
        this.getUserInfo();
      }
    },
    merchantsClick(item) {
      if (this.type === item.type) return;
      this.type = item.type;
      this.countdownSocketStarted = false;
      this.countdownSocketVersion = 0;
      this.openMenu = false;
      clearInterval(this.interval);
      clearTimeout(this.timer);
      clearTimeout(this.timer1);
      this.timer = null;
      this.interval = null
      this.timer1 = null;
      this.$nextTick(() => {
        this.getRoomData();
        this.getOrders();
      })
    },
    getNewDxdsLength() {
      return this.newDxdsCode.reduce((acc, value) => acc + value.length, 0)
    },
    newDxdsClick(item, index, num) {
      if (this.newDxdsCode[index - 1].includes('大') && item.value == '小') return Toast(this.$t('大小不能同时选择'));
      if (this.newDxdsCode[index - 1].includes('小') && item.value == '大') return Toast(this.$t('大小不能同时选择'));
      if (this.newDxdsCode[index - 1].includes('单') && item.value == '双') return Toast(this.$t('单双不能同时选择'));
      if (this.newDxdsCode[index - 1].includes('双') && item.value == '单') return Toast(this.$t('单双不能同时选择'));
      if (this.newDxdsCode[index - 1].includes(item.value)) {
        this.$set(this.newDxdsCode, index - 1, this.newDxdsCode[index - 1].replace(item.value, ''))
      } else {
        this.$set(this.newDxdsCode, index - 1, this.newDxdsCode[index - 1] + item.value)
      }
    },
    qqClick(index) {
      const idx = this.qqSelectArr.indexOf(index);
      if (idx !== -1) {
        this.qqSelectArr.splice(idx, 1);
      } else {
        this.$set(this.qqSelectArr, this.qqSelectArr.length, index);
      }
    },
    toRecord() {
      this.$router.push("cart");
    },
    toRecharge() {
      Dialog.alert({
        title: this.$t('My.MemberInformation.Recharge'),
        message: this.$t('hint.lxkf'),
        showCancelButton: true,
        confirmButtonText: this.$t('Login.goLoginText'),
        cancelButtonText: this.$t('newAdd.Cancel')
      }).then(() => {
        this.$api.toService();
      }).catch(() => {
      });
      return;
      // this.$router.push("/new-recharge");
    },
    toWithdraw() {
      this.$router.push("/new-withdraw");
    },
    // 跳转客服
    toService() { },
    dialogSubmit() {
      const arrItem = this.type + this.lastCurrent.expect
      this.dialogArr.push(arrItem);
      this.dialogShow = false;
    },
    // 获取房间信息
    async getRoomData() {
      try {
        const res = await $get("/lottery/setting", {
          type: this.type,
          explain: 1,
        });
        const { ret, msg, data } = res.data;
        this.configs = data[0];
        this.games = [];
        this.qqArr = [];
        this.ruleContent = this.configs.method_explain;
        this.dxdsArr = [];

        if (this.configs.type.indexOf('hl') > -1) {
          const games = data[0].oddtrees[0].items.hz;
          const dxdsKeys = ['big', 'small', 'single', 'dual'];
          const keys = Object.keys(games).filter(item => (item.indexOf('dxds') < 0 && dxdsKeys.indexOf(item) < 0));

          for (const key in games) {
            if (Object.hasOwnProperty.call(games, key)) {
              const value = games[key];
              if (value) {
                switch (key) {
                  case 'big':
                    value.title = "大"
                    break;
                  case 'small':
                    value.title = "小"
                    break;
                  case 'single':
                    value.title = "单"
                    break;
                  case 'dual':
                    value.title = "双"
                    break;
                  default:
                    break;
                }
                if (dxdsKeys.includes(key)) {
                  value.method = `hz-hz-${key}`
                  this.dxdsArr.push(value)
                }
              }
            }
          }
          for (const key of keys) {
            const value = games[key];
            value.title = key;
            value.method = `hz-hz-${key}`;
            this.games.push(value);
          }
          return
        }
        const newArr = data[0].odds;
        this.isFindIndex = newArr.findIndex(item => item.method == 'dxds') >= 0 ? true : false;
        this.newDxdsArr = [...newArr];
        const result = {};
        for (const item of newArr) {
          result[item.method] = { ...item };
        }
        this.newResultDxds = { ...result };

        const games = data[0].odds;
        const zhKey = games.find(item => item.method == 'zh');
        const dxdsKeys = ['big', 'small', 'single', 'dual'];
        for (const key of dxdsKeys) {
          const value = {};
          if (value) {
            switch (key) {
              case 'big':
                value.title = "大"
                break;
              case 'small':
                value.title = "小"
                break;
              case 'single':
                value.title = "单"
                break;
              case 'dual':
                value.title = "双"
                break;
              default:
                break;
            }
            value.method = zhKey.method;
            value.odds = zhKey.odds;
            this.dxdsArr.push(value);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 获取订单
    async getOrders(pageSize = 2, flag = false, callback = () => { }) {
      Toast.loading();
      const requestedType = String(this.type);
      const socketVersionWhenRequested = this.countdownSocketVersion;
      try {
        const res = await $get("/lottery/lists", {
          type: requestedType,
          pagesize: pageSize,
        });
        if (requestedType !== String(this.type)) {
          Toast.clear();
          return;
        }
        const { ret, msg, data } = res.data;
        const { last_win, last_bet } = data
        const arrItem = this.type + data.lists[1].expect
        this.last_win = last_win
        const preserveSocketCountdown = flag || (this.countdownSocketStarted &&
          this.countdownSocketVersion !== socketVersionWhenRequested);
        const socketCurrent = preserveSocketCountdown
          ? { ...this.currentGame, countdown: this.countTime }
          : null;
        const current = socketCurrent
          ? { ...data.lists[0], ...socketCurrent }
          : data.lists[0];
        this.orderLists = socketCurrent
          ? [current, ...data.lists.slice(1)]
          : data.lists;
        this.currentGame = current;
        this.lastCurrent = data.lists[1];
        if (this.dialogArr.includes(arrItem)) {
        } else {
          const arrs = JSON.parse(cookie.get('gameExpect') || '{}')
          const findExpect = arrs[this.type]
          if (Number(last_bet) && Number(last_win) > 0 && findExpect != data.lists[1].expect) {
            this.dialogShow = true;
            cookie.set('gameExpect', JSON.stringify({ ...arrs, [this.type]: data.lists[1].expect }))
            // Dialog.alert({
            //   title: this.$t('你赢了'),
            //   message: this.$t('赢了', { money: last_win }),
            //   confirmButtonText: this.$t('Button.confirm')
            // }).then(() => {
            //   this.dialogArr.push(arrItem)
            // });
          }
        }
        callback();
        if (!flag && !preserveSocketCountdown) {
          this.addInterval(current.countdown);
        }
        this.dailyBet = data.total_bet;
        this.dailyWin = data.total_win;
        this.user_money = data.user_money;
        Toast.clear();
      } catch (error) {
        Toast.clear();
      }
    },
    // 状态判断
    getStatus(item) {
      if (!item) return;
      const { status, open } = item;
      switch (status) {
        case "待开奖":
          return this.$t("status.waiting");
          break;
        case "已开奖":
          const data = open.dxds[0];
          // const nums = open.dwd;
          // for(let i=0,len=nums.length;i<len;i++){
          //   const i=0;
          // }
          let res = "";
          res = this.getStatusText(data.dx);
          res += "\n" + this.getStatusText(data.ds);
          return res;
          break;
        case "开奖出错":
          return this.$t("status.fail");
          break;
        default:
          return "";
          break;
      }
    },
    getStatusText(text) {
      switch (text) {
        case "大":
          return this.$t("open.big");
          break;
        case "小":
          return this.$t("open.small");
        case "单":
          return this.$t("open.single");
        case "双":
          return this.$t("open.double");
        default:
          return text;
      }
    },
    getStatusTexts(text) {
      return text.split("")
      // switch (text) {
      //   case "大":
      //     return this.$t("open.big");
      //     break;
      //   case "小":
      //     return this.$t("open.small");
      //   case "单":
      //     return this.$t("open.single");
      //   case "双":
      //     return this.$t("open.double");
      //   default:
      //     return text;
      // }
    },
    // 选择
    select({ value }) {
      const b = this.selectArr.find((a) => a == value);
      if (this.selectArr.includes('大') && value == '小') return Toast(this.$t('大小不能同时选择'));
      if (this.selectArr.includes('小') && value == '大') return Toast(this.$t('大小不能同时选择'));
      if (this.selectArr.includes('单') && value == '双') return Toast(this.$t('单双不能同时选择'));
      if (this.selectArr.includes('双') && value == '单') return Toast(this.$t('单双不能同时选择'));
      if (!b) {
        this.selectArr.push(value);
      } else {
        const newArr = [...this.selectArr];
        this.selectArr = newArr.filter((item) => item !== value);
      }
    },
    numSelect({ title }) {
      const b = this.numSelectArr.find((a) => a == title);
      const nums = Math.floor(this.games.length * 0.7)
      if (!b) {
        if (this.numSelectArr.length > nums - 1) {
          Toast(this.$t('数字最多选择', { num: nums }))
          return
        }
        this.numSelectArr.push(title);
      } else {
        const newArr = [...this.numSelectArr];
        this.numSelectArr = newArr.filter((item) => item !== title);
      }
    },
    txffcSelect({ value }, index) {
      let itemData = this.txffcSelectData[index];
      if (itemData) {
        const b = itemData.find((a) => a == value);
        if (!b) {
          itemData.push(value);
        } else {
          const newArr = [...itemData];
          itemData = newArr.filter((item) => item !== value);
        }
      } else {
        itemData = [value];
      }
      this.$set(this.txffcSelectData, index, itemData);
    },
    // 获取用户信息
    getUserInfo() {
      if (!this.userInfo.level) {
        this.$api.getUserInfo((res) => {
          this.userInfo = res;
          subscribeLotteryUser(res && res.id, cookie.get('token') || '');
        });
      }
    },
    clear() {
      this.perPrice = "";
      this.selectArr = [];
      this.numSelectArr = [];
      this.qqSelectArr = [];
      this.newDxdsCode = ['', '', '', '', '']
    },
    toConfirmMatch() {
      if (!this.showInput && !this.getNewDxdsLength()) {
        this.$toast(this.$t("hint.toAddOrder"));
        return;
      }
      if (this.perPrice == "") {
        this.$toast(this.$t("hint.toPerPrice"));
        return;
      }
      if (!this.countTime) {
        this.$toast(this.$t("hint.opening"));
        return;
      }
      this.buyShow = true;
    },
    toMatch() {
      Dialog.confirm({
        message: this.$t("hint.confirmBet"),
        cancelButtonText: this.$t("My.Button.One"),
        confirmButtonText: this.$t("My.Button.Two"),
      }).then(() => this.submitMatch()).catch(() => {});
    },
    async submitMatch() {
      if (!([...this.selectArr, ...this.numSelectArr, ...this.qqSelectArr].length + this.txffcMatchNum + this.getNewDxdsLength()) || this.perPrice == "") return;
      // this.perPrice * this.selectArr.length
      if (Number(this.userInfo.money) < (this.matchAmount + this.getNewDxdsLength() + this.qqSelectArr.length) * (this.perPrice || 0)) {
        return this.$toast(this.$t("hint.moneyLess"));
      }
      if (!this.countTime) {
        this.$toast(this.$t("hint.opening"));
        return;
      }
      const promiseArr = [];
      let txffcMatchStr = "";
      if (this.txffcMatchNum) {
        const arr = [];
        for (let i = 0, len = this.txffcGames.length; i < len; i++) {
          arr.push(this.txffcSelectData[i] || []);
        }
        let num = 0;
        txffcMatchStr = arr.reduce((prev, current) => {
          if (num == 0) {
            num++;
            return current.join("");
          }
          return prev + `,${current.join("")}`;
        }, "");
        promiseArr.push(
          post("/lottery/send", {
            type: this.type,
            // expect: this.orderLists[0].expect,
            expect: this.currentGame.expect,
            method: "dxds",
            code: txffcMatchStr,
            money: this.perPrice,
            mtype: "yuan",
          })
        );
      }
      // Toast.loading();
      if (!!this.getNewDxdsLength()) {
        promiseArr.push(
          post("/lottery/send", {
            type: this.type,
            expect: this.currentGame.expect,
            method: 'dxds',
            code: this.newDxdsCode.join(','),
            money: this.perPrice,
            mtype: "yuan",
          })
        );
      }
      // if (!!this.selectArr.length) {
      for (let i = 0, len = this.selectArr.length; i < len; i++) {
        const items = this.selectArr[i]
        const obj = this.dxdsArr.find(item => item.title == items);
        promiseArr.push(
          post("/lottery/send", {
            type: this.type,
            // expect: this.orderLists[0].expect,
            expect: this.currentGame.expect,
            method: obj.method,
            code: items,
            money: this.perPrice,
            mtype: "yuan",
          })
        );
      }
      // }
      for (let i = 0, len = this.numSelectArr.length; i < len; i++) {
        const item = this.numSelectArr[i];
        promiseArr.push(
          post("/lottery/send", {
            type: this.type,
            // expect: this.orderLists[0].expect,
            expect: this.currentGame.expect,
            method: "hz-hz-" + item,
            code: item,
            money: this.perPrice,
            mtype: "yuan",
          })
        );
      }
      for (let i = 0, len = this.qqSelectArr.length; i < len; i++) {
        const item = this.qqSelectArr[i];
        promiseArr.push(
          post("/lottery/send", {
            type: this.type,
            expect: this.currentGame.expect,
            method: 'dx-dwd',
            code: item,
            money: this.perPrice,
            mtype: "yuan",
          })
        );
      }
      Promise.all(promiseArr)
        .then((res) => {
          this.buyShow = false;
          this.clear();
          this.$toast(this.$t("hint.matchSuccess"));
          let timer = setTimeout(() => {
            this.getUserInfo();
            this.getOrders(2, true);
            clearInterval(timer)
            timer = null;
          }, 1000);
        })
        .catch((err) => {
          // this.$toast(this.$t("hint.matchFail"));
          this.$toast(err.msg || this.$t("hint.matchFail"))
        });
      // try {
      //   const res = await post("/lottery/send", {
      //     type: this.type,
      //     expect: this.orderLists[0].expect,
      //     method: "hz-hz-dxds",
      //     code: this.selectArr.join(""),
      //     money: this.perPrice,
      //     mtype: "yuan",
      //   });
      //   this.buyShow = false;
      //   const { ret, msg, data } = res.data;
      //   this.clear();
      //   Toast.clear();
      //   if (ret == 1) {
      //   this.$toast(this.$t("hint.matchSuccess"));
      //   this.getUserInfo();
      //   return;
      //   }
      //   this.$toast(this.$t("hint.matchFail"));
      // } catch (error) {
      //   Toast.clear();
      //   this.$toast(this.$t("hint.matchFail"));
      // }
    },
    // 定时器
    addInterval(countTime) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null
      }
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null
      }
      if (this.timer1) {
        clearTimeout(this.timer1);
        this.timer1 = null;
      }
      this.countTime = Math.max(0, Number(countTime) || 0);
      this.intervalFun();
      if (this.countTime <= 0) return;
      this.interval = setInterval(() => {
        this.countTime = Math.max(0, this.countTime - 1);
        this.intervalFun();
      }, 1000);
    },
    format(num) {
      if (num >= 10) return num;
      else return "0" + num;
    },
    intervalFun() {
      this.countTime = Math.max(0, Number(this.countTime) || 0);
      const hourUnit = 60 * 60;
      const minuteUnit = 60;
      const secondUnit = 1;
      const targetH = Math.floor(this.countTime / hourUnit);
      const targetM = Math.floor((this.countTime % hourUnit) / minuteUnit);
      const targetS = Math.floor(
        ((this.countTime % hourUnit) % minuteUnit) / secondUnit
      );
      if (!this.countTime) {
        clearInterval(this.interval);
        this.interval = null;
        this.countText = this.$t("status.open");
        return;
      }
      this.countText = `${this.format(targetH)}:${this.format(
        targetM
      )}:${this.format(targetS)}`;
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearTimeout(this.timer);
    clearTimeout(this.timer1);
    this.timer = null;
    this.interval = null
    this.timer1 = null;
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener(LOTTERY_OPENING_EVENT, this.handleLotteryOpening);
    window.removeEventListener(LOTTERY_RESULT_EVENT, this.handleLotteryResult);
    window.removeEventListener(LOTTERY_ORDER_SETTLED_EVENT, this.handleLotteryOrderSettled);
    cancelAllRequests();
  },
  destroyed() {
    clearInterval(this.interval);
    clearTimeout(this.timer);
    clearTimeout(this.timer1);
    this.timer = null;
    this.interval = null
    this.timer1 = null;
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener(LOTTERY_OPENING_EVENT, this.handleLotteryOpening);
    window.removeEventListener(LOTTERY_RESULT_EVENT, this.handleLotteryResult);
    window.removeEventListener(LOTTERY_ORDER_SETTLED_EVENT, this.handleLotteryOrderSettled);
    cancelAllRequests();
  }
};
</script>

<style lang="less" scoped>
.wrap {
  @import url("@/assets/iconfonts/iconfont.css");
  @bg: var(--black);
  @bgBlod: var(--navTheme);
  @black: var(--navTheme);
  @activeColor: var(--yellow);
  min-height: 100vh;
  background-color: var(--bg);

  /deep/ .van-dialog {
    .van-dialog__header {
      padding: 0;
      line-height: 52px;
      background: var(--bg);
      color: var(--light);
    }

    .van-dialog__content {
      padding: 20px;

      .rule_cont {
        max-height: 60vh;
        overflow-y: scroll;
      }
    }
  }

  .menu_popup {
    background-color: transparent;

    .menu {
      width: 60%;
      margin: 0 auto;
      margin-top: 46px;
      border-radius: 10px;
      overflow: hidden;
      background: linear-gradient(-90deg, #ff3a3e, #ff1e30);
      box-shadow: 0 5px 10px 0 rgba(255, 0, 16, .4);

      .menu_list {
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        color: var(--light);
        font-size: calc(14rem / 16);
      }

      .menu_active {
        background: linear-gradient(180deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);
        color: #333;
      }
    }
  }

  /deep/ .van-dialog__header {
    padding-top: 18px;
    font-size: 20px;
  }

  .nav_title {
    .icon-xiangxia {
      font-size: 16px;
      color: @activeColor;
      margin-left: 5px;
    }
  }

  .nav_tools_item {
    margin: 0 6px;
    color: var(--light);
    font-size: 20px;

    &:nth-last-of-type(1) {
      margin-right: 0;
    }
  }

  .flex(@position: "") {
    display: flex;
    flex-direction: @position;
  }

  .ver(@position: center) {
    align-items: @position;
  }

  .hor(@position: center) {
    justify-content: @position;
  }

  .nav_left_wrap {
    display: flex;
    align-items: center;

    >.left_title {
      color: var(--textColor);
      margin-left: 5px;
    }
  }

  .right_popup_wrap {
    @topHeight: 46px;

    /deep/ .van-overlay {
      height: clac(100vh - @topHeight);
      top: @topHeight;
    }

    /deep/ .van-popup--top {
      top: @topHeight;
    }

    /deep/ .van-popup {
      top: @topHeight;
      background-color: transparent;
    }

    .tool_wrap {
      position: fixed;
      right: calc(10rem / 16);
      padding: 0 calc(10rem / 16);
      background-color: #fff;
      border-radius: calc(6rem / 16);
      z-index: 999;

      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        border: calc(10rem / 16) solid transparent;
        border-bottom-color: #fff;
        top: calc(-20rem / 16);
        right: calc(5rem / 16);
      }

      .tool_item {
        @height: calc(42rem / 16);
        width: calc(100rem / 16);
        height: @height;
        line-height: @height;
        text-align: center;
        border-bottom: 1px solid #ccc;
      }
    }
  }

  .top_wrap {
    padding-top: calc(12rem / 16);
    display: flex;
    background: var(--navBg);
    margin: calc(12rem / 16) calc(12rem / 16) 0;
    border-radius: 10px 10px 0 0;

    >div {
      width: 50%;
      text-align: center;

      .text {
        font-size: calc(14rem / 16);
        color: var(--btnsizeColor);

        >span {
          // color: #d80b2a;
          color: @activeColor;
        }
      }
    }

    // @font-face {
    //   font-family: 'countFont';
    //   src: url();
    // }
    .left {
      border-right: 1px dashed #DF8C8C;
      padding-bottom: calc(12rem / 16);

      .time {
        // font-family: countFont;
        // color: #d80b2a;
        margin-top: 6px;
        color: @activeColor;
        font-size: calc(28rem / 16);
        line-height: calc(36rem / 16);
        display: flex;
        align-items: center;
        justify-content: center;

        .time_num {
          display: flex;
          align-items: center;

          div {
            background: linear-gradient(180deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);
            color: #7E1414;
            font-size: calc(16rem / 16);
            width: calc(30rem / 16);
            height: calc(30rem / 16);
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          span {
            margin: 0 calc(7rem / 16)
          }
        }
      }
    }

    .right {
      padding-bottom: calc(12rem / 16);

      .status {
        font-size: calc(12rem / 16);
        line-height: calc(36rem / 16);
        color: @activeColor;
        display: flex;
        justify-content: center;
        margin-top: 6px;
        align-items: center;
        flex-wrap: wrap;

        >img {
          width: 30px;
          height: 30px;
          margin-left: 10px;

          &:nth-of-type(1) {
            margin-left: 0;
          }
        }

        .ball_wrap {
          .ball {
            border-radius: 50%;
            width: calc(26rem / 16);
            line-height: calc(26rem / 16);
            margin: 1px;
            background: var(--theme);
            color: #000;
            display: inline-block;
            background-image: url("../../../assets/icon/game_ball.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
        }

        .ball_wraps {
          display: flex;
          align-items: center;
          gap: calc(8rem / 16);

          .ball_img {
            .img {
              width: calc(30rem / 16);
              height: calc(30rem / 16);
              display: block;
            }
          }
        }

        .sum_ball {
          border-radius: 50%;
          margin: 1px;

          >span {
            margin-left: calc(8rem / 16);

            &:nth-child(1) {
              margin-left: 0;
            }
          }
        }

        .icon-xiangxia {
          font-size: 16px;
          color: @activeColor;
          margin-left: 20px;
        }
      }

      .txffc {
        flex-direction: column;
      }
    }
  }

  .daily_trade_info {
    display: flex;
    padding-bottom: calc(12rem / 16);
    background-color: var(--navBg);
    margin: 0 calc(12rem / 16) calc(12rem / 16);
    border-radius: 10px;

    >div {
      width: 50%;
      padding: 10px 0;
      text-align: center;

      .label {
        color: var(--btnsizeColor);
        font-size: 12px;
      }

      .value {
        margin-top: 20px;
        color: var(--yellow);
      }
    }

    .bet {
      border-right: 1px dashed #DF8C8C;
      border-top: 1px dashed #DF8C8C;
    }

    .win {
      border-top: 1px dashed #DF8C8C;
    }

    .lefts {
      margin-top: calc(12rem / 16);
      border-right: 1px dashed #DF8C8C;

      &:nth-child(2) {
        border-right: none;
      }
    }
  }


  .content_wrap {
    padding: 0 calc(8rem / 16);
    padding-bottom: calc(136rem / 16);

    .type_title {
      color: #999;
      text-align: center;
      margin-top: calc(16rem / 16);
    }

    .newGame {
      display: flex;
      flex-direction: column;
      gap: calc(12rem / 16);


      .gameLists {
        background-color: var(--navBg);
        margin: 0 4px;
        border-radius: 10px;
        padding: calc(10rem / 16) calc(13rem / 16) calc(20rem / 16);

        >.title {
          text-align: center;
          color: var(--btnsizeColor);
          font-size: calc(16rem / 16);
          padding-bottom: calc(12rem / 16);
          border-bottom: 1px dashed #DF8C8C;
        }

        .list {
          display: flex;
          justify-content: space-between;

          &_value {
            border-radius: 4px;
            background: transparent;
            width: 23%;
            margin-top: calc(13rem / 16);
            min-height: calc(46rem / 16);
            border: 1px solid var(--yellow);
            padding: 5px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            color: var(--btnsizeColor);

            .title {
              font-size: calc(18rem / 16);
            }

            .value {
              margin-top: 3px;
              color: var(--gray1);
              opacity: 0.7;
            }
          }

          .list_active {
            color: #fea931;
            border-color: #fea931;
            border-width: 1px;
            width: calc(23% - 1px);
            background: linear-gradient(180deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);

            .title {
              color: #7E1414;
            }

            .value {
              color: rgba(126, 20, 20, 0.6);
              ;
            }
          }
        }
      }
    }

    .select_wraps {
      .all_title {
        text-align: center;
        margin-top: calc(13rem / 16);
        color: var(--btnsizeColor);
        font-size: calc(16rem / 16);
        padding-bottom: calc(12rem / 16);
        border-bottom: 1px dashed #DF8C8C;
      }

      .select_wrap {
        margin-top: calc(20rem / 16);
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        background: var(--navBg);
        margin: 4px;
        padding: calc(19rem / 16) calc(13rem / 16);
        gap: calc(15rem / 16) 0;
        border-radius: 10px;

        .select_item {
          @height: calc(46rem / 16);
          border-radius: 4px;
          background: rgba(239, 75, 59, 0.15);
          font-size: calc(18rem / 16);
          width: 23%;
          min-height: @height;
          border: 1px solid var(--yellow);
          padding: 5px 0;
          display: flex;
          align-items: center;
          flex-direction: column;
          color: var(--btnsizeColor);

          >p {
            &:nth-last-child(1) {
              margin-top: 3px;
              color: var(--gray1);
              opacity: 0.7;
            }
          }
        }

        .active {
          color: #7E1414;
          border-color: @activeColor;
          border-width: 1px;
          width: calc(23% - 1px);
          height: calc(46rem / 16 - 1px);
          background: linear-gradient(180deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);

          >p:nth-last-child(1) {
            color: rgba(126, 20, 20, 0.6);
          }
        }
      }
    }

    ._wrap {
      background-color: var(--navBg);
      border-radius: 10px;
      padding: calc(10rem / 16) calc(13rem / 16) calc(20rem / 16);
      margin-top: calc(12rem / 16) !important;

      .all_title {
        margin-top: 0;
      }

      .select_wrap {
        padding: calc(13rem / 16) 0 0;
      }
    }

    .select_qq {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .select_item {
        @height: calc(46rem / 16);
        border-radius: 4px;
        background: transparent;
        font-size: calc(18rem / 16);
        width: 48%;
        margin-top: calc(13rem / 16);
        min-height: @height;
        border: 1px solid var(--theme);
        padding: 10px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        color: var(--btnsizeColor);

        >p {
          &:nth-last-child(1) {
            margin-top: 8px;
            color: var(--gray1);
            opacity: 0.7;
          }
        }
      }

      .active {
        color: @activeColor;
        border-color: @activeColor;
        border-width: 2px;
        width: calc(48% - 2px);
        height: calc(46rem / 16 - 2px);

        >p:nth-last-child(1) {
          color: @activeColor;
        }
      }
    }

    .img_wrap {
      @item_gap: calc(16rem / 16);
      @img_size: calc();
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: calc(18rem / 16);

      .img_item {
        @size: calc((100% - @item_gap * 3) / 4 - 2px);
        width: @size;
        height: @size;
        margin-right: @item_gap;
        margin-bottom: @item_gap;
        border-radius: 4px;

        // border: 1px solid #f1c8c8;
        &:nth-child(4n) {
          margin-right: 0;
        }

        &:nth-last-child(1),
        &:nth-last-child(2),
        &:nth-last-child(3),
        &:nth-last-child(4) {
          margin-bottom: 0;
        }
      }
    }

    .qq_top {
      border: 1px solid var(--theme);
      border-radius: 4px;
      overflow: hidden;

      .qq_game_top {
        color: var(--light);
        background-color: #163350;
        display: flex;
        align-items: center;
        padding: 6px 0;
        font-size: calc(14rem / 16);

        .game_item {
          width: calc(100% / 3);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          &_title {
            text-align: center;
            text-wrap: wrap;
            overflow-wrap: break-word;
            white-space: wrap;
          }

          .game_odds {
            margin-top: 4px;
          }
        }
      }

      .qq_select {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        row-gap: calc(14rem / 16);
        padding: calc(12rem / 16) 0;

        .qq_img {
          width: calc(100% / 3);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: var(--light);

          .imgs {
            background-color: transparent;
            border-radius: 10px;
          }

          .img {
            width: 60px;
            height: 60px;
            display: block;
          }

          .qq_img_num {
            font-size: calc(14rem / 16);
            margin-top: calc(10rem / 16);
            text-align: center;
          }
        }

        .qq_active {
          color: var(--gold);

          .imgs {
            background-color: var(--gold);
          }
        }
      }
    }
  }

  .footer {
    @height: calc(50rem / 16);
    @border: 1px solid @black;
    position: fixed;
    bottom: 0;
    width: 100vw;
    background: var(--navBg);
    z-index: 10;

    .input_wrap {
      border-top: @border;
      display: flex;
      align-items: center;
      padding: calc(5rem / 16) 0;
      @height: calc(26rem / 16);
      justify-content: space-between;
      background: var(--navBg);

      >div {
        width: 50%;
        height: @height;
        display: flex;
        align-items: center;
      }

      .left {
        @left: calc(15rem / 16);
        padding-left: @left;
        // width: calc(50% - @left);
        flex-grow: 1;
        font-size: calc(14rem / 16);
        display: flex;
        align-items: center;
        color: var(--btnsizeColor);

        >input {
          text-indent: calc(5rem / 16);
          width: calc(120rem / 16);
          margin: 0 calc(12rem / 16);
          height: calc(@height - 2px);
          border-radius: 2px;
          // border: 1px solid @black;
          border: 1px solid #b8ecff;
          background: transparent;
          color: @activeColor;
        }
      }

      .clear {
        width: calc(58rem / 16);
        height: calc(100% - 16px);
        // padding: calc(5rem / 16);
        // margin-top: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left: 1px solid #aaa;
        color: @activeColor;
      }
    }

    .bottom {
      @height: calc(50rem / 16);
      display: flex;
      // border-top: @border;
      height: @height;
      width: 100vw;
      align-items: center;
      justify-content: space-between;
      // background: @black;
      background: rgba(239, 75, 59, 0.15);

      .right {
        font-size: calc(14rem / 16);
        height: fit-content;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-left: calc(16rem / 16);
        color: var(--light);

        >.price {
          // color: #d80b2a;
          color: @activeColor;
          margin-left: calc(6rem / 16);
        }
      }

      .buy {
        width: calc(120rem / 16);
        height: 100%;
        line-height: @height;
        text-align: center;
        // color: var(--textColor);
        // background-color: #d80b2a;
        background: @activeColor;
        color: @black;
        font-weight: bold;
      }
    }
  }

  .buy_pop {
    @title_height: calc(50rem / 16);
    background: var(--bg);

    .title {
      @height: @title_height;
      line-height: @height;
      height: @height;
      font-size: calc(18rem / 16);
      text-align: center;
      background-color: var(--navBg);
      color: var(--btnsizeColor);
    }

    .titles {
      @height: @title_height;
      line-height: @height;
      height: @height;
      font-size: calc(18rem / 16);
      text-align: center;
      color: var(--btnsizeColor);
    }

    .content {
      padding: calc(12rem / 16) 0;
      margin: 0 calc(24rem / 16);
      border-bottom: 1px solid #e5e5e5;

      .li {
        display: flex;
        // color: #666;
        // color: #b8ecff;
        color: var(--btnsizeColor);
        font-size: calc(14rem / 16);
        padding: calc(6rem / 16);

        >div {
          .flex();
          // .ver(flex-end);
          flex-wrap: wrap;
        }

        .left {
          // min-width: calc(90rem / 16);
          white-space: nowrap;
        }

        .right {
          margin-left: calc(6rem / 16);

          .right_new {
            display: flex;
            margin-bottom: calc(5rem / 16);

            .number {
              width: calc(16rem / 16);
              height: calc(16rem / 16);
              border-radius: 50%;
              border: 1px solid var(--light);
              color: var(--light);
              display: flex;
              align-items: center;
              justify-content: center;
            }

            margin-left: calc(5rem / 16);

            .new_list {
              .value {}
            }

            .new_list:nth-last-of-type(1) {
              .icon {
                display: none;
              }
            }
          }
        }

        .right_qq {
          margin-left: calc(6rem / 16);
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          .qq_img {
            .img {
              width: 40px;
              height: 40px;
              display: block;
            }
          }
        }
      }
    }

    .hint {
      padding: calc(12rem / 16);
      text-align: center;
      color: #df8c8c;
    }

    .btn_wrap {
      padding: calc(12rem / 16);
      margin-bottom: calc(12rem / 16);

      .btn {
        color: var(--textColor);
        background-color: #d80b2a;
        font-size: calc(20rem / 16);
        text-align: center;
        line-height: calc(40rem / 16);
        border-radius: calc(6rem / 16);
        color: var(--btnsizeColor);
      }
    }

    .sticky {
      position: sticky;
      top: 0;
      background-color: #fff;
      z-index: 999;

      .title {
        position: relative;

        .icon {
          position: absolute;
          height: @title_height;
          .flex();
          .ver(center);
          top: 0;
          left: 16px;
        }
      }
    }

    .title_bar {
      .flex();
      border-bottom: 1px solid #eee;

      .li {
        width: calc(100% / 3);
        text-align: center;
        line-height: calc(36rem / 16);
        color: #999;
      }
    }

    .list_wrap {
      position: relative;

      .li_wrap {
        --big: #f9982e;
        --small: #7f8ab0;
        .flex();

        .li {
          width: calc(100% / 3);
          line-height: calc(36rem / 16);
          font-size: calc(12rem / 16);
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;

          >img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
            border: 1px solid #eee;

            &:nth-child(1) {
              margin-left: 46px;
            }
          }

          &:nth-child(1) {
            color: #666;
          }
        }

        &:nth-child(2n) {
          background-color: #eee;
        }
      }
    }
  }

  .wins {
    background: var(--bg);

    /deep/ .van-dialog__content {
      padding: 0;
    }

    img {
      width: 100%;
      height: calc(140rem / 16);
      display: block;
    }

    .win_cont {
      padding: 0 calc(20rem / 16) calc(30rem / 16);

      .title {
        text-align: center;
        font-size: calc(16rem / 16);
        color: var(--light);
      }

      .subtitle {
        color: var(--light);
        margin-top: calc(15rem / 16);
        font-size: calc(14rem / 16);
        text-align: center;

        span {
          font-size: calc(22rem / 16);
          font-weight: 700;
          background: linear-gradient(180deg, #FBE599 0%, #F9DB76 49%, #FBE699 72%, #EEB452 99%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
      }

      .btn {
        width: fit-content;
        margin: 0 auto;
        margin-top: calc(24rem / 16);
        padding: calc(10rem / 16) calc(50rem / 16);
        color: #7F1414;
        line-height: calc(20rem / 16);
        border-radius: 100px;
        font-size: calc(16rem / 16);
        background: linear-gradient(181deg, #FBE599 3%, #F9DB76 49%, #FBE699 70%, #EEB452 95%);
      }
    }
  }
}
</style>
